/**
 * Build query params for getSubscriptionHistory. Drops empty values.
 */
export function buildSubscriptionHistoryParams(filters, page, limit) {
  const params = { page, limit };
  if (filters.user_id) params.user_id = filters.user_id;
  if (filters.name) params.name = String(filters.name).trim();
  if (filters.email) params.email = String(filters.email).trim();
  if (filters.contactNo) params.contactNo = String(filters.contactNo).trim();
  if (filters.date_from) params.date_from = filters.date_from;
  if (filters.date_to) params.date_to = filters.date_to;
  if (filters.subscription) params.subscription = filters.subscription;
  if (filters.source) params.source = filters.source;
  if (filters.record_state) params.record_state = String(filters.record_state).toLowerCase();
  if (filters.payment_method) params.payment_method = String(filters.payment_method).trim();
  if (filters.currency) params.currency = String(filters.currency).trim();
  if (filters.status) params.status = String(filters.status).trim();
  if (filters.emailType) params.emailType = filters.emailType;
  return params;
}
